import { Info } from 'lucide-react';

import { NumberedSteps } from '~/components/common/NumberedSteps';
import { Alert, AlertDescription } from '~/components/ui/alert';
import { getTelegramBotName } from '~/config';

/**
 * How to link a Telegram chat through the DeadDrop bot: an intro alert and
 * four numbered steps. Shared by the connect dialog and onboarding.
 */
export function TelegramConnectSteps({ className }: { className?: string }) {
  const telegramBotName = getTelegramBotName();

  return (
    <div className={className}>
      <Alert className="mb-4">
        <Info className="text-primary" />
        <AlertDescription>
          To connect a Telegram chat, you'll need to interact with our bot.
        </AlertDescription>
      </Alert>

      <p className="mb-4">Follow these steps:</p>

      <NumberedSteps>
        <li>
          Open Telegram and search for{' '}
          <span className="font-mono font-bold">@{telegramBotName}</span>
        </li>
        <li>Open a chat with the bot and click "Start"</li>
        <li>Click the connection link the bot sends you</li>
        <li>Select the topic you want to connect</li>
      </NumberedSteps>
    </div>
  );
}
